// src/redux/slices/recipesSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";

// Async thunk to fetch all recipes
export const fetchRecipes = createAsyncThunk(
  "recipes/fetch",
  async (filters = "") => {
    let params = {};
    // Default pagination
    let pageOneBased = 1;
    let limit = 12;

    if (typeof filters === "string") {
      params.q = filters;
    } else if (filters && typeof filters === "object") {
      const {
        q = "",
        days = [],
        dates = [],
        categories = [],
        openOnly = true,
        preset = "",
        batchLimit = 4,
        page = 1,
        limit: lim = 12,
      } = filters;
      params.q = q;
      if (preset) params.preset = preset;
      params.batchLimit = Math.max(parseInt(batchLimit || 4, 10) || 4, 1);
      if (Array.isArray(days) && days.length) params.day = days.join(",");
      if (Array.isArray(dates) && dates.length) params.dates = dates.join(",");
      if (Array.isArray(categories) && categories.length)
        params.categories = categories.join(",");
      params.openOnly = String(openOnly);
      pageOneBased = Math.max(parseInt(page || 1, 10) || 1, 1);
      limit = Math.max(parseInt(lim || 12, 10) || 12, 1);
    }

    // API expects zero-based page index
    params.page = pageOneBased - 1;
    params.limit = limit;

    const response = await api.get("/recipes", { params });
    const { recipes = [], total = 0, page = 0, limit: apiLimit = limit } =
      response.data || {};
    return {
      items: Array.isArray(recipes) ? recipes : [],
      total: Number(total) || 0,
      // store page as 1-based for UI
      page: Number(page) + 1,
      limit: Number(apiLimit) || limit,
    };
  }
);

const recipesSlice = createSlice({
  name: "recipes",
  initialState: {
    items: [],
    total: 0,
    page: 1,
    limit: 12,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecipes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRecipes.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.items || [];
        state.total = action.payload.total || 0;
        state.page = action.payload.page || 1;
        state.limit = action.payload.limit || 12;
      })
      .addCase(fetchRecipes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Error fetching recipes";
      });
  },
});

export default recipesSlice.reducer;
